//Инициализация Intersection Observer для ленивой загрузки изображений
export const initLazyLoadObserver = (selector) => {
  const images = selector.querySelectorAll('img[v-lazy]');
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if(!entry.isIntersecting) return;
      const img = entry.target;
      const src = img.getAttribute('v-lazy');
      if(src){
        img.setAttribute('src', src);
        img.removeAttribute('v-lazy');
      }
      observer.unobserve(img);
    }, { rootMargin: '20px 0px -400px 0px' });
  });
  images.forEach(img => observer.observe(img));
};